<section id="canvasVideoComponent" class="viewerAsset viewerAssetVideoCanvas">
  <div id="canvasVideoWrapper" class="d-flex flex-column mx-auto justify-content-center align-items-center">
    <div class="w-100">
      <zbp-viewer-video [asset]="asset" (loaded)="completedVideoLoading()" (withError)="withError.emit($event)"></zbp-viewer-video>
    </div>
    <div class="w-100">
      <zbp-viewer-canvas
        [asset]="asset"
        [series]="series"
        [grade]="grade"
        [selectedTool]="selectedTool"
        (loaded)="completeImageLoading()"
        (withError)="withError.emit($event)">
      </zbp-viewer-canvas>
    </div>
  </div>
</section>
